class HeaderTabBar {
  constructor() {
    this.init();
  }

  init() {
    this.tabBar = document.querySelector('.header__inline-menu .list-menu--inline');
    if (!this.tabBar) return;

    this.setupScrollIndicators();
    this.setupActiveItemScroll();
    this.setupTouchScroll();
  }

  setupScrollIndicators() {
    // Add scroll indicators if needed
    const checkScroll = () => {
      const hasScroll = this.tabBar.scrollWidth > this.tabBar.clientWidth;
      if (hasScroll) {
        this.tabBar.classList.add('has-scroll');
      } else {
        this.tabBar.classList.remove('has-scroll');
        this.tabBar.classList.remove('scrolled-to-start', 'scrolled-to-end');
      }
      this.updateScrollIndicatorStates();
    };

    checkScroll();
    window.addEventListener('resize', checkScroll);
    
    // Update scroll indicator states on scroll
    this.tabBar.addEventListener('scroll', () => {
      this.updateScrollIndicatorStates();
    });
  }

  updateScrollIndicatorStates() {
    if (!this.tabBar.classList.contains('has-scroll')) return;

    const isAtStart = this.tabBar.scrollLeft <= 0;
    const isAtEnd = this.tabBar.scrollLeft >= this.tabBar.scrollWidth - this.tabBar.clientWidth - 1;

    this.tabBar.classList.toggle('scrolled-to-start', isAtStart);
    this.tabBar.classList.toggle('scrolled-to-end', isAtEnd);
  }

  setupActiveItemScroll() {
    // Scroll active item into view on load
    const activeItem = this.tabBar.querySelector('.header__active-menu-item');
    if (activeItem) {
      setTimeout(() => {
        this.scrollItemIntoView(activeItem.closest('li'));
      }, 100);
    }

    // Handle click events to scroll items into view
    this.tabBar.addEventListener('click', (e) => {
      const menuItem = e.target.closest('.header__menu-item');
      if (menuItem) {
        this.scrollItemIntoView(menuItem.closest('li'));
      }
    });
  }

  scrollItemIntoView(item) {
    if (!item) return;

    const tabBarRect = this.tabBar.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();

    // Check if item is partially or fully out of view
    if (itemRect.left < tabBarRect.left || itemRect.right > tabBarRect.right) {
      // Calculate scroll position to center the item
      const scrollLeft = this.tabBar.scrollLeft + (itemRect.left - tabBarRect.left) - (tabBarRect.width / 2) + (itemRect.width / 2);
      
      this.tabBar.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }
  }

  setupTouchScroll() {
    let startX = 0;
    let scrollLeft = 0;
    let isDown = false;

    this.tabBar.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - this.tabBar.offsetLeft;
      scrollLeft = this.tabBar.scrollLeft;
      this.tabBar.style.cursor = 'grabbing';
    });

    this.tabBar.addEventListener('mouseleave', () => {
      isDown = false;
      this.tabBar.style.cursor = 'grab';
    });

    this.tabBar.addEventListener('mouseup', () => {
      isDown = false;
      this.tabBar.style.cursor = 'grab';
    });

    this.tabBar.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - this.tabBar.offsetLeft;
      const walk = (x - startX) * 2;
      this.tabBar.scrollLeft = scrollLeft - walk;
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new HeaderTabBar();
});

// Re-initialize if header is dynamically loaded
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new HeaderTabBar();
  });
}
